import styled from 'styled-components';

import {
  Grid as SemanticGrid,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  padding: 0px 10px;
`;

const Grid = styled(SemanticGrid)`
  &&& {
    margin: 0px;
  }
`;

const Row = styled(SemanticGrid.Row)`
`;

const Column = styled(SemanticGrid.Column)`
  ${(props) => props.lastChild
    && `
      &&&&&& {
        display: flex;
        justify-content: flex-end;
      }
    `
  }
`;

const Header = styled(TextLayoutComponent.Bold)``;

const Data = styled(TextLayoutComponent)``;

const NoDataMessage = styled(TextLayoutComponent)`
  margin-top: 20px;
`;

const Link = styled.a`
  &[data-converted-key="false"] {
    pointer-events: none;
    color: #ccc;
  }
`;

const LinkRed = styled.a`
  color: #ff0000;
`;

export {
  Column,
  Container,
  Data,
  Grid,
  Header,
  Link,
  LinkRed,
  NoDataMessage,
  Row,
};
